module.exports = __webpack_public_path__ + "static/img/icon7-11.59c56bb8.png";